/**
 * Colocação da lista "Notas de todos" (mesma regra da API, util/colocacaoNotas): primeiro quem recebeu o mínimo
 * de notas (metade do maior número de notas), por maior média; empate pelas notas 4-5★ e depois pelo total de
 * notas. Abaixo, quem recebeu poucas notas. Aplicada aqui também porque resultados antigos foram gravados em
 * outra ordem. Devolve { avaliacoes, minimoVotos }.
 */
export function colocacaoDasNotas(lista = []) {
  const maxVotos = Math.max(0, ...lista.map((a) => a.votos));
  const minimoVotos = Math.max(1, Math.ceil(maxVotos / 2));
  const ordem = (a, b) => b.media - a.media || (b.positivas || 0) - (a.positivas || 0) || b.votos - a.votos;
  const avaliacoes = [
    ...lista.filter((a) => a.votos >= minimoVotos).sort(ordem),
    ...lista.filter((a) => a.votos < minimoVotos).sort(ordem),
  ];
  return { avaliacoes, minimoVotos };
}

export default colocacaoDasNotas;
